import { useCallback, useEffect, useState } from 'react';
import { getPPALeadGenFee } from 'api/ppaOnboarding';
import { TLeadGenFeeInfo } from 'types/common';

//base on specialty
const useGetPPALeadGenFee = (): [TLeadGenFeeInfo | undefined, boolean, () => Promise<void>] => {
    const [data, setData] = useState<TLeadGenFeeInfo | undefined>();
    const [loading, setLoading] = useState(false);

    const fetch = useCallback(async () => {
        setLoading(true);
        try {
            const res = await getPPALeadGenFee();
            if (res && !res.error) {
                setData(res.data?.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return [data, loading, fetch];
};

export default useGetPPALeadGenFee;
